import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { db } from "../firebaseConfig";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";

const HEARTBEAT_INTERVAL_MS = 15000;

function getSessionCalcId() {
  if (typeof window === "undefined") return "";
  try {
    return (
      window.sessionStorage?.getItem("loanId") ||
      window.sessionStorage?.getItem("calcId") ||
      ""
    );
  } catch (err) {
    console.warn("SessionStorage read failed:", err);
    return "";
  }
}

export default function PresenceTracker() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");
  const isLogin = location.pathname.startsWith("/login");

  useEffect(() => {
    if (isDashboard || isLogin) return;
    let isMounted = true;
    let intervalId = null;

    const updatePresence = async () => {
      if (!isMounted) return;
      const calcId = getSessionCalcId();
      if (!calcId) return;
      try {
        await setDoc(
          doc(db, "calculateEntries", calcId),
          { lastSeenAt: serverTimestamp() },
          { merge: true }
        );
      } catch (err) {
        console.warn("Presence update failed:", err);
      }
    };

    const handleVisibility = () => {
      if (document.visibilityState === "hidden") {
        updatePresence();
      }
    };

    updatePresence();
    intervalId = setInterval(updatePresence, HEARTBEAT_INTERVAL_MS);
    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("pagehide", handleVisibility);

    return () => {
      isMounted = false;
      if (intervalId) clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("pagehide", handleVisibility);
    };
  }, [isDashboard, isLogin]);

  return null;
}
